if (!customElements.get('allseating-builder-test')) {
  customElements.define('allseating-builder-test', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-builder-open]');
      this.models = this.querySelector('[data-builder-model]');
      this.frame = this.querySelector('.as-builder-frame');
      this.models.addEventListener('change', () => this.updateModel());
      this.opener.addEventListener('click', () => this.open());
      this.querySelector('[data-builder-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        if (this.originalUrl && location.pathname === new URL(this.originalUrl).pathname) {
          history.replaceState(history.state, '', this.originalUrl);
        }
        this.opener.focus();
      });
      this.updateModel();
    }

    updateModel() {
      const model = this.models.selectedOptions[0];
      if (!model) return;
      this.querySelectorAll('a[href^="https://www.allseating.com/products/"]').forEach(link => {
        link.href = model.dataset.url;
      });
      if (this.embed && this.embed.getAttribute('short-code') !== model.value) {
        this.embed.remove();
        this.embed = null;
      }
    }

    open() {
      if (this.dialog.open) return;
      this.originalUrl = location.href;
      const cleanUrl = new URL(this.originalUrl);
      cleanUrl.searchParams.delete('variantCode');
      history.replaceState(history.state, '', cleanUrl);
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      if (this.embed) return;
      const embed = document.createElement('mmq-embed');
      embed.setAttribute('short-code', this.models.value);
      embed.setAttribute('template', 'custom_ui_new');
      embed.setAttribute('locale', 'en-us');
      for (const name of ['adjust-to-container', 'hide-header', 'hide-price', 'hide-qty', 'hide-finish', 'hide-pdf-price']) {
        embed.setAttribute(name, 'true');
      }
      embed.setAttribute('with-history', 'false');
      this.frame.append(embed);
      this.embed = embed;
      if (!document.querySelector('script[data-as-mimeeq]')) {
        const script = document.createElement('script');
        script.src = 'https://cdn.mimeeq.com/read_models/embed/app-embed.js';
        script.async = true;
        script.dataset.asMimeeq = 'true';
        document.body.append(script);
      }
    }
  });
}
